import { useEffect, useState } from 'react';

interface LiveTimerProps {
  since: string | number;
}

/**
 * Tiempo transcurrido desde `since` (hh:mm:ss), actualizado cada segundo. Devuelve solo el texto: el tamaño, el color y
 * las cifras tabulares los pone el contenedor.
 */
export default function LiveTimer({ since }: LiveTimerProps) {
  const [, setTick] = useState(0);

  useEffect(() => {
    const interval = window.setInterval(() => setTick((t) => t + 1), 1000);
    return () => window.clearInterval(interval);
  }, []);

  const from = typeof since === 'number' ? since : new Date(since).getTime();
  const diffMs = Date.now() - from;
  if (diffMs < 0) return <>00:00:00</>;
  const hours = Math.floor(diffMs / 3600000);
  const minutes = Math.floor((diffMs % 3600000) / 60000);
  const seconds = Math.floor((diffMs % 60000) / 1000);

  return <>{`${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`}</>;
}
